export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "active_claims_warning_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sinistres en cours"])},
        "active_claims_warning_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La modification du prix, de la date d'achat ou du n° de série (Reference ID) du produit mettra également à jour le produit dans les sinistres en cours (non résolus, non annulés, non refusés)."])},
        "birth_date_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de naissance"])},
        "purchase_date_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date d'achat"])},
        "purchase_date_in_future": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La date d'achat ne peut pas être dans le futur"])}
      },
      "en": {
        "active_claims_warning_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active claims"])},
        "active_claims_warning_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Updating the product price, purchase date or serial number (Reference ID) will also update the product in all active claims (not resolved, not cancelled, not refused)."])},
        "birth_date_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date of birth"])},
        "purchase_date_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Purchase date"])},
        "purchase_date_in_future": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The purchase date cannot be in the future"])}
      }
    }
  })
}
